(() => {
  'use strict';
  const source = document.getElementById('CarryReviewsData');
  const root = document.querySelector('[data-carry-reviews]');
  if (!source || !root || root.dataset.ready === 'true') return;
  const data = JSON.parse(source.textContent), ui = data.ui, reviews = data.reviews;
  const list = root.querySelector('[data-carry-review-list]');
  const sort = root.querySelector('[data-carry-review-sort]');
  const search = root.querySelector('[data-carry-review-search]');
  const more = root.querySelector('[data-carry-review-more]');
  const status = root.querySelector('[data-carry-review-status]');
  const clear = root.querySelector('[data-carry-review-clear]');
  const empty = root.querySelector('[data-carry-review-empty]');
  const photos = reviews.flatMap(review => review.photos.map((photo, localIndex) => ({ ...photo, review, key: review.id + ':' + localIndex })));
  const photoIndex = new Map(photos.map((photo, index) => [photo.key, index]));
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  let limit = 6, filter = 'all', rating = 'all', searchTimer, renderedQuery = '';
  const ratingToggle = root.querySelector('[data-carry-rating-toggle]');
  const searchToggle = root.querySelector('[data-carry-search-toggle]');
  if (ratingToggle) {
    ratingToggle.hidden = false;
    ratingToggle.addEventListener('click', () => {
      const expanded = ratingToggle.getAttribute('aria-expanded') !== 'true';
      ratingToggle.setAttribute('aria-expanded', String(expanded));
      ratingToggle.querySelector('span').textContent = expanded ? ui.hideRatingDetails : ui.ratingDetails;
      root.classList.toggle('is-rating-expanded', expanded);
    });
  }
  if (searchToggle) {
    searchToggle.hidden = false;
    searchToggle.addEventListener('click', () => {
      const expanded = searchToggle.getAttribute('aria-expanded') !== 'true';
      searchToggle.setAttribute('aria-expanded', String(expanded));
      searchToggle.querySelector('span').textContent = expanded ? ui.closeSearch : ui.searchButton;
      root.classList.toggle('is-search-expanded', expanded);
      if (expanded) search.focus({ preventScroll: true });
      else { clearTimeout(searchTimer); search.value = ''; limit = 6; render(); }
    });
  }
  const normalized = text => String(text || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase(data.locale);
  const searchIndex = new Map(reviews.map(r => [r.id, normalized([r.author, r.title, r.body, r.originalTitle, r.originalBody].join(' '))]));
  const node = (tag, cls, text) => {
    const el = document.createElement(tag);
    if (cls) el.className = cls;
    if (text != null) el.textContent = text;
    return el;
  };
  const button = (cls, text, action) => {
    const el = node('button', cls, text); el.type = 'button';
    if (action) el.addEventListener('click', action);
    return el;
  };
  function thumbUrl(url, width) {
    const result = new URL(url); result.searchParams.set('width', String(width)); return result.href;
  }
  function stars(value) {
    const el = node('span', 'carry-review-stars');
    el.setAttribute('role', 'img'); el.setAttribute('aria-label', value + ' / 5');
    for (let n = 1; n <= 5; n++) {
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('aria-hidden', 'true');
      if (n > value) svg.classList.add('is-empty');
      const path = document.createElementNS(svg.namespaceURI, 'path');
      path.setAttribute('d', 'm12 2.5 2.94 5.96 6.58.96-4.76 4.64 1.12 6.55L12 17.52l-5.88 3.09 1.12-6.55L2.48 9.42l6.58-.96Z');
      svg.append(path); el.append(svg);
    }
    return el;
  }
  function person(review) {
    const el = node('header', 'carry-review-person');
    const date = node('time', '', review.dateLabel); date.dateTime = review.date;
    el.append(node('strong', '', review.author), node('span', '', 'HELSINKI'), date);
    if (review.verifiedDiyionPurchase) el.append(node('span', 'dy-review-verified', ({en:'Verified DIYION purchase',fr:'Achat DIYION vérifié',de:'Verifizierter DIYION-Kauf',nl:'Geverifieerde DIYION-aankoop'})[data.locale] || 'Verified DIYION purchase'));
    else if (review.customerOrigin) el.append(node('span', 'dy-review-customer', ({en:'DIYION customer review',fr:'Avis d’un client DIYION',de:'Bewertung eines DIYION-Kunden',nl:'Beoordeling van een DIYION-klant'})[data.locale] || 'DIYION customer review'));
    return el;
  }
  function content(review, { expand = false, modal = false } = {}) {
    const el = node('div', 'carry-review-content');
    const title = node('h3', '', review.title), body = node('p', 'carry-review-body', review.body);
    title.hidden = !review.title; body.lang = data.locale;
    body.id = 'CarryReviewBody-' + review.id + (modal ? '-photo' : '');
    el.append(stars(review.rating), title, body);
    let original = false;
    const longText = Math.max(review.body.length, review.originalBody.length);
    if (!expand && longText > 260) {
      const mobileOnly = longText <= 650, collapseClass = mobileOnly ? 'is-mobile-collapsed' : 'is-collapsed';
      body.classList.add(collapseClass);
      const toggle = button('carry-text-button carry-read-more' + (mobileOnly ? ' carry-read-more--mobile' : ''), ui.readMore, () => {
        const collapsed = body.classList.toggle(collapseClass);
        toggle.textContent = collapsed ? ui.readMore : ui.readLess;
        toggle.setAttribute('aria-expanded', String(!collapsed));
      });
      toggle.setAttribute('aria-expanded', 'false'); toggle.setAttribute('aria-controls', body.id); el.append(toggle);
    }
    if (review.body !== review.originalBody || review.title !== review.originalTitle) {
      const translation = node('div', 'carry-review-translation');
      const label = node('span', '', ui.translated + ' · ');
      const toggle = button('carry-text-button', ui.showOriginal, () => {
        original = !original;
        title.textContent = original ? review.originalTitle : review.title;
        title.hidden = !title.textContent;
        body.textContent = original ? review.originalBody : review.body;
        title.lang = body.lang = original ? review.language : data.locale;
        label.textContent = original ? '' : ui.translated + ' · ';
        toggle.textContent = original ? ui.showTranslation : ui.showOriginal;
      });
      translation.append(label, toggle); el.append(translation);
    } else { title.lang = body.lang = review.language; }
    if (review.incentivized) el.append(node('small', 'carry-review-incentive', ui.incentivized));
    return el;
  }
  function makeCard(review) {
    const card = node('article', 'carry-review-card' + (review.photos.length ? ' has-photos' : ''));
    card.dataset.reviewId = review.id; card.dataset.rating = review.rating; card.tabIndex = -1;
    card.append(person(review), content(review));
    if (review.photos.length) {
      const row = node('div', 'carry-review-card-photos');
      review.photos.forEach((photo, localIndex) => {
        const b = button('', ''), img = node('img');
        b.dataset.carryPhotoId = review.id + ':' + localIndex;
        b.setAttribute('aria-label', ui.photo + ' · ' + review.author);
        b.setAttribute('aria-haspopup', 'dialog'); b.setAttribute('aria-controls', 'CarryReviewPhotos');
        img.src = thumbUrl(photo.thumbUrl, 440); img.width = 160; img.height = 190;
        img.alt = ui.photo + ' — Helsinki'; img.loading = 'lazy'; img.decoding = 'async';
        b.append(img); row.append(b);
      });
      card.append(row);
    }
    return card;
  }
  function matchingReviews() {
    const terms = normalized(search.value.trim()).split(/\s+/).filter(Boolean);
    return reviews.filter(r => (filter === 'all' || r.photos.length) &&
      (rating === 'all' || r.rating === Number(rating)) && terms.every(term => searchIndex.get(r.id).includes(term)))
      .sort((a, b) => (sort.value === 'photos' ? Number(b.photos.length > 0) - Number(a.photos.length > 0)
        : sort.value === 'highest' ? b.rating - a.rating
          : sort.value === 'lowest' ? a.rating - b.rating : 0) || b.date.localeCompare(a.date) || a.id.localeCompare(b.id));
  }
  function render({ append = false } = {}) {
    const matches = matchingReviews();
    renderedQuery = normalized(search.value.trim());
    const start = append ? list.children.length : 0;
    const cards = matches.slice(start, limit).map(makeCard);
    if (append) list.append(...cards); else list.replaceChildren(...cards);
    status.textContent = matches.length ? (matches.length===1 ? (window.DiyionBuyerCopy?.[data.locale]?.reviewOne || ui.showingReviews) : (window.DiyionBuyerCopy?.[data.locale]?.reviewCount || ui.showingReviews)).replace('{shown}', Math.min(limit, matches.length)).replace('{total}', matches.length) +
      (rating === 'all' ? '' : ' · ' + rating + ' / 5') : ui.noMatches;
    more.hidden = matches.length <= limit; empty.hidden = matches.length !== 0;
    clear.hidden = filter === 'all' && rating === 'all' && !search.value.trim();
    root.querySelectorAll('[data-carry-review-filter]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.carryReviewFilter === filter)));
    root.querySelectorAll('[data-carry-rating]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.carryRating === rating)));
    if (append && cards[0]) cards[0].focus({ preventScroll: true });
  }
  function reset() {
    clearTimeout(searchTimer); filter = 'all'; rating = 'all'; search.value = ''; limit = 6; render();
    (root.classList.contains('is-search-expanded') || !matchMedia('(max-width:760px)').matches ? search : searchToggle)?.focus({ preventScroll: true });
  }
  root.querySelector('[data-carry-review-controls]').hidden = false;
  root.querySelectorAll('[data-carry-review-filter]').forEach(b => b.addEventListener('click', () => {
    clearTimeout(searchTimer); filter = b.dataset.carryReviewFilter; limit = 6; render();
  }));
  root.querySelectorAll('[data-carry-rating]').forEach(b => b.addEventListener('click', () => {
    clearTimeout(searchTimer); rating = rating === b.dataset.carryRating ? 'all' : b.dataset.carryRating; limit = 6; render();
    root.querySelector('.carry-review-toolbar').scrollIntoView({ block: 'start', behavior: reducedMotion.matches ? 'auto' : 'smooth' });
  }));
  search.addEventListener('input', () => { clearTimeout(searchTimer); searchTimer = setTimeout(() => { limit = 6; render(); }, 160); });
  sort.addEventListener('change', () => { clearTimeout(searchTimer); limit = 6; render(); });
  clear.addEventListener('click', reset); root.querySelector('[data-carry-review-reset]').addEventListener('click', reset);
  more.addEventListener('click', () => {
    clearTimeout(searchTimer);
    if (normalized(search.value.trim()) !== renderedQuery) { limit = 6; render(); }
    else { limit += 6; render({ append: true }); }
  });

  const strip = root.querySelector('.carry-photo-strip');
  function updateStrip() {
    if (!strip) return;
    root.querySelectorAll('[data-carry-strip-step]').forEach(b => {
      b.disabled = Number(b.dataset.carryStripStep) < 0 ? strip.scrollLeft < 2 : strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 2;
    });
  }
  if (strip) {
    root.querySelector('[data-carry-strip-controls]').hidden = false;
    root.querySelectorAll('[data-carry-strip-step]').forEach(b => b.addEventListener('click', () => {
      strip.scrollBy({ left: Number(b.dataset.carryStripStep) * strip.clientWidth * .8, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
    }));
    strip.addEventListener('scroll', updateStrip, { passive: true });
    new ResizeObserver(updateStrip).observe(strip); updateStrip();
  }

  const dialog = document.getElementById('CarryReviewPhotos');
  const img = dialog.querySelector('[data-carry-review-full]');
  const stage = dialog.querySelector('.carry-review-photo-stage');
  const error = dialog.querySelector('[data-carry-photo-error]');
  const counter = dialog.querySelector('[data-carry-photo-counter]');
  const quote = dialog.querySelector('[data-carry-photo-quote]');
  const thumbs = dialog.querySelector('[data-carry-dialog-thumbs]');
  let index = 0, opener, touchStart;
  function buildThumbs() {
    if (thumbs.children.length) return;
    photos.forEach((photo, at) => {
      const b = button('', '', () => showPhoto(at)), thumb = node('img');
      b.setAttribute('aria-label', ui.photo + ' ' + (at + 1) + ' · ' + photo.review.author);
      thumb.src = thumbUrl(photo.thumbUrl, 120); thumb.width = 52; thumb.height = 58;
      thumb.alt = ''; thumb.loading = 'lazy'; thumb.decoding = 'async'; b.append(thumb); thumbs.append(b);
    });
  }
  function showPhoto(at) {
    const focusedStep = document.activeElement?.closest('[data-carry-photo-step]');
    index = Math.max(0, Math.min(photos.length - 1, at));
    const photo = photos[index]; if (!photo) return;
    img.hidden = false; error.hidden = true; stage.setAttribute('aria-busy', 'true'); img.style.opacity = '.35';
    img.alt = ui.photo + ' — Helsinki · ' + photo.review.author; img.src = photo.fullUrl;
    counter.textContent = (index + 1) + ' / ' + photos.length;
    quote.replaceChildren(person(photo.review), content(photo.review, { expand: true, modal: true })); quote.scrollTop = 0;
    dialog.querySelectorAll('[data-carry-photo-step]').forEach(b => {
      b.disabled = Number(b.dataset.carryPhotoStep) < 0 ? index === 0 : index === photos.length - 1;
    });
    [...thumbs.children].forEach((b, at) => b.setAttribute('aria-pressed', String(at === index)));
    if (focusedStep && dialog.contains(focusedStep) && focusedStep.disabled) thumbs.children[index]?.focus({ preventScroll: true });
    thumbs.children[index]?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
  }
  function openPhoto(at, from) {
    if (!Number.isInteger(at) || !photos[at]) return;
    opener = from; buildThumbs(); dialog.showModal(); showPhoto(at);
  }
  root.addEventListener('click', event => {
    const control = event.target.closest('[data-carry-photo], [data-carry-photo-id]'); if (!control) return;
    const at = control.hasAttribute('data-carry-photo') ? Number(control.dataset.carryPhoto) : photoIndex.get(control.dataset.carryPhotoId);
    openPhoto(at, control);
  });
  img.addEventListener('load', () => { img.style.opacity = '1'; stage.setAttribute('aria-busy', 'false'); });
  img.addEventListener('error', () => { if (!dialog.open || !img.getAttribute('src')) return; img.hidden = true; error.hidden = false; stage.setAttribute('aria-busy', 'false'); });
  dialog.querySelector('[data-carry-photo-retry]').addEventListener('click', () => showPhoto(index));
  dialog.querySelector('[data-carry-review-close]').addEventListener('click', () => dialog.close());
  dialog.querySelectorAll('[data-carry-photo-step]').forEach(b => b.addEventListener('click', () => showPhoto(index + Number(b.dataset.carryPhotoStep))));
  dialog.addEventListener('keydown', event => {
    if (['ArrowLeft', 'ArrowRight'].includes(event.key)) { event.preventDefault(); showPhoto(index + (event.key === 'ArrowRight' ? 1 : -1)); }
  });
  stage.addEventListener('touchstart', event => {
    if (event.touches.length === 1) touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY }; else touchStart = null;
  }, { passive: true });
  stage.addEventListener('touchend', event => {
    if (!touchStart) return;
    const point = event.changedTouches[0], dx = point.clientX - touchStart.x, dy = point.clientY - touchStart.y;
    if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) showPhoto(index + (dx < 0 ? 1 : -1));
    touchStart = null;
  }, { passive: true });
  stage.addEventListener('touchcancel', () => { touchStart = null; }, { passive: true });
  dialog.addEventListener('close', () => {
    img.removeAttribute('src'); img.hidden = true; quote.replaceChildren(); stage.setAttribute('aria-busy', 'false');
    opener?.focus({ preventScroll: true });
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  render(); root.dataset.ready = 'true';
})();
